import { logger } from "@pistonite/pure/log";

export const log = logger("itemsys", { color: "#b2dc9b" });
